export const sortArrAlphabetically = <TInfo extends Record<any, any>>(
  arr: TInfo[],
  field: keyof TInfo,
  isDesc?: boolean,
) => {
  return arr.sort((a, b) =>
    isDesc ? b[field].localeCompare(a[field]) : a[field].localeCompare(b[field]),
  );
};
